export const GAMES = [
  {
    id: 'dama-brasileira',
    title: 'Dama Brasileira',
    status: 'Novo',
    description:
      'Dama 8x8 com regra da maioria, captura obrigatoria, captura multipla e dama voadora.',
    details: [
      'Formato: Damas 8x8',
      'Entrada: Clique/Toque',
      'Foco: Estrategia e leitura de sequencias',
    ],
    tags: ['Tabuleiro', 'Estrategia', 'Damas'],
    href: '/games/dama-brasileira/index.html',
  },
  {
    id: 'paciencia-klondike',
    title: 'Paciencia Klondike',
    status: 'Novo',
    description:
      'Versao classica inspirada no Windows 7, com compras por clique, dicas e fundacoes.',
    details: [
      'Formato: Klondike 1 carta',
      'Entrada: Clique/Toque',
      'Foco: Estrategia e organizacao',
    ],
    tags: ['Cartas', 'Classico', 'Klondike'],
    href: '/games/solitaire/index.html',
  },
  {
    id: 'pulso-farol',
    title: 'Pulso do Farol',
    status: 'Novo',
    description:
      'Jogo de clique ritmico para sincronizar o pulso da luz e marcar pontos em 30 segundos.',
    details: ['Formato: Timing 1-toque', 'Entrada: Clique/Toque', 'Foco: Ritmo e precisao'],
    tags: ['One-click', 'Timing', 'Score'],
    href: '/games/pulso-farol/index.html',
  },
  {
    id: 'reflex-arena',
    title: 'Reflex Arena',
    status: 'Novo',
    description:
      'Competicao de reflexo para 2 ou 3 jogadores com modo local e salas online sincronizadas.',
    details: [
      'Formato: Multiplayer local/online',
      'Entrada: Teclado e toque',
      'Foco: Reacao e disputa rapida',
    ],
    tags: ['Multiplayer', 'Arcade', 'Party game'],
    href: '/games/reflex-arena/index.html',
  },
  {
    id: 'snake',
    title: 'Snake Classic',
    status: 'Arquivo',
    description:
      'Releitura do classico Snake com ranking, ritmo progressivo e foco em controle preciso.',
    details: ['Formato: Arcade 2D', 'Entrada: Teclado', 'Foco: Reflexo e consistencia'],
    tags: ['Canvas', 'Ranking', 'Velocidade'],
    href: '/games/snake/index.html',
  },
  {
    id: 'retro-jump',
    title: 'Retro Jump',
    status: 'Arquivo',
    description:
      'Runner lateral inspirado em jogos retro, com pontuacao progressiva e desafio continuo.',
    details: ['Formato: Side-scroller', 'Entrada: Teclado', 'Foco: Ritmo e timing'],
    tags: ['Canvas', 'Runner', 'Pontuacao'],
    href: '/games/retro-jump-game/src/indexgame.html',
  },
  {
    id: 'lane-switcher',
    title: 'Lane Switcher',
    status: 'Arquivo',
    description: 'Jogo one-button para alternar faixas, desviar de obstaculos e manter o fluxo.',
    details: ['Formato: Hyper-casual', 'Entrada: Clique ou tecla', 'Foco: Fluxo e precisao'],
    tags: ['One-button', 'Minimalista', 'Reflexo'],
    href: '/games/one-button/index.html',
  },
];

export const API_EXPLORATIONS = [
  {
    id: 'swapi',
    eyebrow: 'SWAPI',
    title: 'Explorador da API Star Wars',
    description:
      'Pagina dedicada para explorar Pessoas, Filmes, Planetas, Naves, Especies e Veiculos com busca e paginacao.',
    to: '/laboratorio/swapi',
  },
  {
    id: 'rick-and-morty',
    eyebrow: 'Rick and Morty',
    title: 'Explorador da API Rick and Morty',
    description:
      'Explore Personagens, Locais e Episodios com busca e paginacao em uma interface simples.',
    to: '/laboratorio/rick-morty',
  },
  {
    id: 'futurepedia',
    eyebrow: 'Futurepedia',
    title: 'Back to the Future Wiki',
    description:
      'Pesquisa rapida na wiki oficial da saga com resumo, biografia e links para o site oficial.',
    to: '/laboratorio/back-to-the-future',
    containerClassName: 'md:col-span-2',
  },
];

export const GAMES_PRINCIPLES = [
  {
    id: 'curadoria',
    title: 'Curadoria tecnica',
    description:
      'Jogos escolhidos para exercitar mecanicas simples, feedback claro e boa leitura de estado.',
  },
  {
    id: 'qualidade',
    title: 'Qualidade e consistencia',
    description: 'Loop de jogo leve, regras transparentes e foco em uma experiencia confiavel.',
  },
  {
    id: 'aprendizado',
    title: 'Aprendizado continuo',
    description: 'Cada experimento gera notas sobre balanceamento, controles e usabilidade.',
  },
];

export const GAMES_NOTES = [
  'Os jogos abrem em uma nova aba para manter a navegacao do site intacta.',
  'A maioria roda direto no navegador, sem instalacao ou cadastro.',
  'Alguns rankings usam armazenamento local ou servicos externos para pontuacao.',
];

export const MOVIES_MODAL_COLUMNS = [
  {
    id: 'favoritos',
    title: 'Favoritos',
    description: 'Filmes que voce quer destacar na sua curadoria.',
  },
  {
    id: 'assistidos',
    title: 'Ja assisti',
    description: 'Lista para manter historico e observacoes pessoais.',
  },
  {
    id: 'quero-assistir',
    title: 'Quero assistir',
    description: 'Espaco inicial para futuras descobertas e buscas.',
  },
];
